import {Palette} from 'hubbl-shared';
import {AssetIconProps} from '../types';
import {memo} from 'react';

export const AssetIconEditSimple = memo(
  ({size = 24, color = Palette.almostBlack}: AssetIconProps) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.4852 15.8968L17.0596 3.32234C17.4556 2.92632 17.6537 2.72831 17.882 2.65412C18.0828 2.58887 18.2992 2.58887 18.5 2.65412C18.7283 2.72831 18.9264 2.92632 19.3224 3.32234L20.8644 4.86436C21.2604 5.26038 21.4584 5.45839 21.5326 5.68672C21.5979 5.88756 21.5979 6.10391 21.5326 6.30475C21.4584 6.53308 21.2604 6.73109 20.8644 7.12711L8.28997 19.7015L3.87853 20.3082L4.4852 15.8968Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.7303 6.26965L17.5351 10.0744"
          stroke={color}
          stroke-width="1.5"
        />
      </svg>
    );
  },
);
